
import React, { createContext, useContext, useState } from 'react';

interface SettingsContextType {
  theme: string;
  setTheme: (theme: string) => void;
  showAds: boolean;
  toggleAds: () => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState('light');
  const [showAds, setShowAds] = useState(true);

  const toggleAds = () => {
    setShowAds(!showAds);
  };

  const value = {
    theme,
    setTheme,
    showAds,
    toggleAds,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};
